import { useState } from 'react';
import type { Month } from '../../types';
import type { CalendarEvent } from '../../List/model/types';

export const useProductionCalendarService = () => {
  const [selectedTab, setSelectedTab] = useState<string>();
  const [createModalVisible, setCreateModalVisible] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState<Month>();
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [selectedCalendarEvent, setSelectedCalendarEvent] = useState<CalendarEvent | null>(null);
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);

  const showCreateModal = (month: Month) => {
    setSelectedMonth(month);
    setCreateModalVisible(true);
  };

  const hideCreateModal = () => {
    setCreateModalVisible(false);
    setSelectedMonth(undefined);
  };

  const showEditModal = (month: Month, calendarEvent: CalendarEvent) => {
    setEditModalVisible(true);
    setSelectedMonth(month);
    setSelectedCalendarEvent(calendarEvent);
  };

  const hideEditModal = () => {
    setEditModalVisible(false);
    setSelectedCalendarEvent(null);
    setSelectedMonth(undefined);
  };

  const showDeleteModal = (calendarEvent: CalendarEvent) => {
    setDeleteModalVisible(true);
    setSelectedCalendarEvent(calendarEvent);
  };

  const hideDeleteModal = () => {
    setDeleteModalVisible(false);
    setSelectedCalendarEvent(null);
  };

  const refreshData = () => {
    setRefreshTrigger((prev) => prev + 1);
  };

  return {
    state: {
      selectedTab,
      createModalVisible,
      selectedMonth,
      refreshTrigger,
      selectedCalendarEvent,
      editModalVisible,
      deleteModalVisible,
    },
    methods: {
      setSelectedTab,
      showCreateModal,
      hideCreateModal,
      refreshData,
      showEditModal,
      hideEditModal,
      showDeleteModal,
      hideDeleteModal,
    },
  };
};
